import {
  Download,
  DownloadIcon,
  Eye,
  Loader2,
  MoreVertical,
  Pin,
  Plus,
  Send,
  ThermometerIcon,
  X,
} from "lucide-react";
import { TableCard } from "../../../../component/table/table-layout";
import { TableCard2 } from "../../../../component/table/table-layout";

import StatusChip from "../../../../component/ui/chip/status";
// import Project from "../../../projects/project";
import ProjectTask from "./task";
import Style from "./style.module.css";
import CommentTimeline from "../../../mainAccounts/accountDetails/details/comments";
import { useParams } from "react-router";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import moment from "moment";
import { AnimatePresence, motion } from "framer-motion";
import { Select, Skeleton } from "@mui/material";
import Swal from "sweetalert2";
import ProjectBrief from "./brief-popup";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DetailCommentsSection from "../../../../component/detail-comment";
import CommentsSection from "../../../../component/comment";
import Avatar from "../../../../component/ui/avatar";
import AvatarProfile from "../../../../component/ui/profile";
import { useClickOutside } from "../../../../component/custom-hooks/click-outside";

export default function ProjectDetailMain() {
  const { state } = useContext(GlobalContext);
  const { key } = useParams();
  const [leadDetail, setLeadDetail] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [UsersList, setUsersList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [entityData, setEntityData] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [menuOpen, setMenuOpen] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [showBrief, setShowBrief] = useState(false);
  const commentsEndRef = useRef(null);

  const apiCall = useApiCall();

  const getData = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `projects/get-project/${key}`,
      });
      setLeadDetail(res?.project);
      console.log("Project Detail", res.project);

      const allImages = res?.project?.attachments;

      // const imagesUrls =  allImages?.map(item => item.file_url);
      setAttachments(allImages);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getData();
  }, [key]);

  const downloadFile = (url) => {
    console.log("Attachments", attachments);

    if (!url) {
      console.error("File URL is undefined!");
      return;
    }

    const fileName = url.split("/").pop(); // safe now
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download"; // fallback
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadAllImages = () => {
    attachments?.forEach((file) => {
      downloadFile(file?.file_url);
    });
  };

  // const dummyComments = [
  //   {
  //     user: "T",
  //     name: "Thompson",
  //     time: "1h",
  //     message: "Hello team this is new landing page request from PPC team",
  //   },
  //   {
  //     user: "T",
  //     name: "Thompson",
  //     time: "40m",
  //     message: "We are working on it",
  //   },
  //   {
  //     user: "J",
  //     name: "Jenna",
  //     time: "28m",
  //     message: "Ok Thompson",
  //   },
  //   {
  //     user: "T",
  //     name: "Thompson",
  //     time: "now",
  //     message: "Hello team Jenna, can you take a look?",
  //   },
  //   {
  //     user: "T",
  //     name: "Thompson",
  //     time: "now",
  //     message: "Copy that",
  //   },
  //   {
  //     user: "T",
  //     name: "Thompson",
  //     time: "now",
  //     message: "Thanks everyone",
  //   },
  //   {
  //     user: "J",
  //     name: "Jenna",
  //     time: "now",
  //     message: "Noted!",
  //   },
  //   {
  //     user: "J",
  //     name: "Jenna",
  //     time: "now",
  //     message: "Will update soon",
  //   },
  // ];

  // Assigned User Array

  const [showAll, setShowAll] = useState(false);

  const users = Array.isArray(leadDetail?.assigned_users)
    ? leadDetail?.assigned_users
    : [];

  const visibleUsers = showAll ? users : users.slice(0, 2);
  const hiddenCount = users.length - 3;

  //// Product User dropdown

  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [productionUsers, setProductionUsers] = useState([]);
  const [productionLoading, setProductionLoading] = useState(false);
  // const [filteredUsers, setFilteredUsers] = useState([]);

  const getUsers = async () => {
    setProductionLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "users/production-users-list",
      });

      setProductionUsers(res?.data || []);
      console.log("Production DAta load", res?.data);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    } finally {
      setProductionLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const remainingUsers = useMemo(() => {
    if (productionUsers?.length == 0) return [];

    const assignedUserIds = new Set(users?.map((u) => u?.user?.userid));

    return productionUsers?.filter(
      (user) => !assignedUserIds.has(user?.userid),
    );
  }, [users, productionUsers]);

  // useEffect(() => {
  //   if (search.trim() === "") {
  //     setFilteredUsers(remainingUsers);
  //   } else {
  //     setFilteredUsers(
  //       remainingUsers?.filter((u) =>
  //         u.name.toLowerCase().includes(search.toLowerCase())
  //       )
  //     );
  //   }
  // }, [search, productionUsers]);

  const filteredUsers = useMemo(() => {
    if (!search.trim()) return remainingUsers;

    return remainingUsers.filter((u) =>
      u.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, remainingUsers]);

  const addAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this user in project?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      console.log("User cancelled");
      return;
    }

    let data = {
      project_id: leadDetail?.projectid,
      user_id: user?.userid,
    };

    try {
      const url = `project/assign-user-to-project`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "Assigned User Successfully",
        timer: 1500,
      });

      setShowDropdown(false);
      getData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      setShowDropdown(false);
    }
  };

  const assignedRef = useRef(null);

  useClickOutside(assignedRef, () => {
    setShowAll(false);
  });

  const assignedDropdownRef = useRef(null);

  useClickOutside(assignedDropdownRef, () => {
    setShowDropdown(false);
  });

  return (
    <>
      <div className={` ${Style.mainBody} relative z-30`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <TableCard>
              <div className="flex w-full gap-1">
                <div className="w-2/5 border p-4 rounded-[10px] border-gray-200">
                  {isLoading ? (
                    <>
                      <div className="animate-pulse">
                        {/* Status + Team */}
                        <div className="flex items-center gap-[25px]">
                          <div className="h-5 w-24 rounded-full bg-gray-200" />
                          <div className="h-3 w-20 rounded bg-gray-200" />
                        </div>

                        {/* Title */}
                        <div className="mt-[10px]">
                          <div className="h-6 w-64 rounded bg-gray-200 mb-2" />
                          <div className="h-3 w-24 rounded bg-gray-200" />
                        </div>

                        {/* Progress */}
                        <div className="flex mt-[15px] gap-2 items-center">
                          <div className="h-3 w-20 rounded bg-gray-200" />
                          <div className="h-3 w-10 rounded bg-gray-200" />

                          <div className="w-full h-[2px] bg-gray-200 rounded overflow-hidden">
                            <div className="h-full w-1/3 bg-gray-300 rounded" />
                          </div>
                        </div>

                        {/* Assigned Users */}
                        <div className="flex mt-[17px] gap-2 items-center">
                          <div className="h-3 w-28 rounded bg-gray-200" />

                          <div className="flex -space-x-2">
                            {[1, 2, 3].map((_, i) => (
                              <div
                                key={i}
                                className="h-8 w-8 rounded-full bg-gray-200 border-2 border-white"
                              />
                            ))}
                            <div className="h-8 w-8 rounded-full bg-gray-300 border-2 border-white" />
                          </div>

                          {/* Add button skeleton */}
                          <div className="h-7 w-7 rounded-full bg-gray-200 ml-2" />
                        </div>

                        {/* Project Owner */}
                        <div className="flex mt-[17px] gap-2 items-center">
                          <div className="h-3 w-28 rounded bg-gray-200" />
                          <div className="h-3 w-40 rounded bg-gray-200" />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center gap-[25px]">
                        <StatusChip color="blue">In-Process</StatusChip>

                        <li className="text-[12px] font-normal">Brand Team</li>
                      </div>
                      <div className="mt-[10px]">
                        <h2 className="text-[22px] mb-[5px]">
                          {leadDetail?.customer_details?.name} /{" "}
                          {leadDetail?.invoiceid}
                        </h2>
                        <span className="text-[12px] font-medium">
                          {leadDetail?.startdate}
                        </span>
                      </div>

                      <div className="flex mt-[15px] gap-1 items-center">
                        <p className="text-[13px]">Completion</p>
                        <p className="text-[13px] text-[rgba(14,18,27,0.6)]">
                          14.3%
                        </p>

                        <div className="w-full h-[2px] bg-gray-200">
                          <div
                            className="h-[2px] bg-green-500 rounded-full"
                            style={{ width: `14%` }}
                          ></div>
                        </div>
                      </div>

                      <div className="flex mt-[17px] gap-1 items-center">
                        <p className="text-[13px]">Assigned Users:</p>

                        {/* Users initials */}

                        <div className="relative" ref={assignedRef}>
                          <div
                            className="flex -space-x-2 cursor-pointer"
                            onClick={() => {
                              setShowAll(!showAll);
                              setShowDropdown(false);
                            }}
                          >
                            {leadDetail?.assigned_users?.length > 0 &&
                              leadDetail?.assigned_users.slice(0, 3)?.map(
                                (each, idx) => (
                                  <Avatar
                                    src={each?.user?.userimg}
                                    title={each?.user?.name}
                                    className="border-2 border-gray-200 shadow-sm "
                                  />
                                ),
                                // each?.user?.userimg ? (
                                //   <img
                                //     src={each?.user?.userimg}
                                //     alt={each?.user?.name}
                                //     className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                //     onError={(e) => {
                                //       e.target.onerror = null;
                                //       e.target.style.display = "none";
                                //       const fallback =
                                //         document.createElement("div");
                                //       fallback.className =
                                //         "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                //       fallback.innerText = (
                                //         (each?.user?.name?.split(
                                //           " ",
                                //         )[0]?.[0] || "") +
                                //         (each?.user?.name?.split(
                                //           " ",
                                //         )[1]?.[0] || "")
                                //       ).toUpperCase();
                                //       e.target.parentElement.appendChild(
                                //         fallback,
                                //       );
                                //     }}
                                //   />
                                // ) : (
                                //   <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                //     {(each?.user?.name?.split(" ")[0]?.[0] ||
                                //       "") +
                                //       (each?.user?.name?.split(" ")[1]?.[0] ||
                                //         "")}
                                //   </div>
                                // ),
                              )}

                            {hiddenCount > 0 && (
                              <div className="-ml-2 z-10 h-8 w-8 flex items-center justify-center rounded-full bg-[#0057FB] text-white text-xs font-medium border-2 border-white shadow-sm cursor-pointer">
                                +{hiddenCount}
                              </div>
                            )}
                          </div>
                          {/* show add assigned user dropdown */}

                          {showAll && (
                            <div className="absolute top-10  left-0 right-0 w-60 border border-[#f6f6f6]  bg-white rounded-xl shadow-xl p-3 z-30 overflow-hidden">
                              <div className="flex justify-between items-center mb-2  p-1 border-gray-400 border-b">
                                <h4 className="text-sm font-medium">
                                  Assigned Users
                                </h4>
                                <button
                                  onClick={() => setShowAll(false)}
                                  className="p-1 rounded hover:bg-gray-100 transition"
                                >
                                  <X className="w-4 h-4 text-gray-500 hover:text-black" />
                                </button>
                              </div>

                              <div className="!overflow-y-auto w-full max-h-52  h-full ">
                                {leadDetail?.assigned_users?.map(
                                  (each, idx) => (
                                    <div
                                      key={idx}
                                      className="flex items-center gap-2 p-1   hover:bg-slate-100 transition-all duration-300"
                                    >
                                      {/* <div className="">
                                        {each?.user?.userimg ? (
                                          <img
                                            src={each?.user?.userimg}
                                            alt={each?.user?.name}
                                            className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.style.display = "none";
                                              const fallback =
                                                document.createElement("div");
                                              fallback.className =
                                                "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                              fallback.innerText = (
                                                (each?.user?.name?.split(
                                                  " ",
                                                )[0]?.[0] || "") +
                                                (each?.user?.name?.split(
                                                  " ",
                                                )[1]?.[0] || "")
                                              ).toUpperCase();
                                              e.target.parentElement.appendChild(
                                                fallback,
                                              );
                                            }}
                                          />
                                        ) : (
                                          <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                            {(each?.user?.name?.split(
                                              " ",
                                            )[0]?.[0] || "") +
                                              (each?.user?.name?.split(
                                                " ",
                                              )[1]?.[0] || "")}
                                          </div>
                                        )}
                                      </div>

                                      <span className="text-sm">
                                        {each?.user?.name}
                                      </span> */}
                                      <AvatarProfile
                                        src={each?.user?.userimg}
                                        title={each?.user?.name}
                                        className="text-sm"
                                      />
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div>
                          <div
                            className="projectDetail-cardLeftUserAddBtn selectUser"
                            ref={assignedDropdownRef}
                          >
                            <button
                              className="bg-[#0057FB] text-white flex text-[12px] p-1 rounded-full items-center gap-1 selectUser-btn cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDropdown(!showDropdown);
                                setShowAll(false);
                              }}
                            >
                              {" "}
                              <Plus className="h-5 w-5" />
                            </button>

                            {/* Dropdown */}
                            {showDropdown && (
                              <div className="selectUser-view customSearch mt-2 border border-[#f6f6f6] shadow-xl p-3 rounded-xl  bg-white w-64 absolute   z-20">
                                <div className="selectUser-search flex items-center gap-2  mb-2 border-gray-400 border-b pb-1">
                                  <div className="icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask1"
                                        style={{ maskType: "alpha" }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="18"
                                      >
                                        <rect
                                          width="18"
                                          height="18"
                                          fill="#D9D9D9"
                                        ></rect>
                                      </mask>
                                      <g mask="url(#mask1)">
                                        <path
                                          d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                                          fill="#999999"
                                        ></path>
                                      </g>
                                    </svg>
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Search User..."
                                    className="customSearchInput border rounded px-2 py-1 w-full"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                  />
                                </div>

                                <div className="selectUser-list max-h-48 overflow-y-auto">
                                  <ul className="customSearchList ProjectAssignUsersList">
                                    {filteredUsers?.map((user) => (
                                      <li
                                        key={user?.userid}
                                        className="UserForAssign flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-100 rounded"
                                        onClick={() => {
                                          addAssigned(user);
                                        }}
                                      >
                                        {/* <div className="">
                                          {user?.userimg ? (
                                            <img
                                              src={user?.userimg}
                                              alt={user?.name}
                                              className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = "none";
                                                const fallback =
                                                  document.createElement("div");
                                                fallback.className =
                                                  "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                fallback.innerText = (
                                                  (user?.name?.split(
                                                    " ",
                                                  )[0]?.[0] || "") +
                                                  (user?.name?.split(
                                                    " ",
                                                  )[1]?.[0] || "")
                                                ).toUpperCase();
                                                e.target.parentElement.appendChild(
                                                  fallback,
                                                );
                                              }}
                                            />
                                          ) : (
                                            <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                              {(user?.name?.split(
                                                " ",
                                              )[0]?.[0] || "") +
                                                (user?.name?.split(
                                                  " ",
                                                )[1]?.[0] || "")}
                                            </div>
                                          )}
                                        </div>
                                        <em>{user?.name}</em> */}
                                        <AvatarProfile
                                          src={user?.userimg}
                                          title={user?.name}
                                          className="text-sm"
                                        />
                                      </li>
                                    ))}
                                    {productionLoading && (
                                      <li className="p-2 text-center text-gray-400 text-sm">
                                        Loading...
                                      </li>
                                    )}
                                    {filteredUsers?.length == 0 && (
                                      <li className="p-1 text-gray-400">
                                        No users found
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex mt-[17px] gap-1 items-center">
                        <p className="text-[13px]">Project Owner:</p>
                        <span className="text-[13px] text-[rgba(14,18,27,0.6)]">
                          {" "}
                          Riz Ahmed {leadDetail?.teams.length ? "," : null}
                          {leadDetail?.teams?.map((each, i) => {
                            return (
                              <span
                                key={i}
                                className="text-[13px] text-[rgba(14,18,27,0.6)]"
                              >
                                {" "}
                                {each?.team_name}
                              </span>
                            );
                          })}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div className="w-3/5 border p-4 rounded-lg border-gray-200 bg-[#FAFBFC]">
                  {isLoading ? (
                    <>
                      <div className="animate-pulse">
                        {/* Project name + menu */}
                        <div className="flex justify-between items-start">
                          <div>
                            <div className="h-3 w-24 bg-gray-200 rounded mb-1" />
                            <div className="h-3 w-40 bg-gray-200 rounded" />
                          </div>

                          <div className="h-4 w-4 bg-gray-200 rounded" />
                        </div>

                        {/* Description */}
                        <div className="mt-[15px]">
                          <div className="h-3 w-40 bg-gray-200 rounded mb-1" />
                          <div className="space-y-1">
                            <div className="h-3 w-full bg-gray-200 rounded" />
                            <div className="h-3 w-5/6 bg-gray-200 rounded" />
                            <div className="h-3 w-4/6 bg-gray-200 rounded" />
                          </div>
                        </div>

                        {/* Attached Brief */}
                        <div className="flex mt-[17px] gap-2 items-center">
                          <div className="h-3 w-32 bg-gray-200 rounded" />
                          <div className="h-6 w-24 bg-gray-200 rounded-md" />
                        </div>

                        {/* Attachments + download */}
                        <div className="flex mt-[17px] gap-2 items-center flex-wrap">
                          <div className="h-3 w-44 bg-gray-200 rounded" />

                          <div className="flex gap-2">
                            {[1, 2, 3].map((_, i) => (
                              <div
                                key={i}
                                className="h-3 w-16 bg-gray-200 rounded"
                              />
                            ))}
                          </div>

                          <div className="h-6 w-28 bg-gray-200 rounded-md" />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex justify-between">
                        <div>
                          <p className="text-[12px] mb-[1px]">Project Name:</p>
                          <span className="text-[12px] text-[rgba(14,18,27,0.6)]">
                            {leadDetail?.projectname}
                          </span>
                        </div>

                        <div>
                          <MoreVertical className="w-4 h-4 text-[#999999]" />
                        </div>
                      </div>

                      <div className="mt-[15px]">
                        <p className="text-[12px] mb-[1px]">
                          About This Project:
                        </p>
                        <span className="text-[12px] text-[rgba(14,18,27,0.6)]">
                          {leadDetail?.projectdescription}
                        </span>
                      </div>

                      <div className="flex mt-[17px] gap-1 items-center">
                        <p className="text-[13px]">Attached Brief:</p>
                        <div>
                          {leadDetail?.briefs?.length > 0 ? (
                            <button
                              className="bg-[#0057FB] text-white flex text-[12px] py-[4px] px-2 rounded-md items-center gap-1"
                              onClick={() => setShowBrief(true)}
                            >
                              {" "}
                              <Eye className="h-4 w-4" /> View Brief
                            </button>
                          ) : (
                            <span className="text-sm text-slate-500 italic">
                              No Briefs available
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex mt-[17px] gap-1 items-center">
                        <p className="text-[13px]">Project File Attachment:</p>

                        <div className="flex gap-1">
                          {leadDetail?.attachments?.map((each, i) => {
                            return (
                              <Tooltip
                                content={each?.file_name}
                                position={"bottom center"}
                                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                              >
                                <span>
                                  <a
                                    className="text-[12px]"
                                    href={each?.file_url}
                                    target="_blank"
                                  >
                                    {" "}
                                    {each?.file_name?.length > 15
                                      ? `${each?.file_name?.slice(0, 15)}...`
                                      : each?.file_name}
                                  </a>
                                </span>
                              </Tooltip>
                            );
                          })}
                          {/* <span>
                        <a className="text-[12px]" href="#">
                          File 1.jpg,
                        </a>
                      </span>
                      <span>
                        <a className="text-[12px]" href="#">
                          File 2.jpg,
                        </a>
                      </span>
                      <span>
                        <a className="text-[12px]" href="#">
                          File 3.jpg,
                        </a>
                      </span>
                      <span>
                        <a className="text-[12px]" href="#">
                          File 4.jpg,
                        </a>
                      </span> */}
                        </div>
                        <div>
                          <button
                            className="bg-[#0057FB] text-white flex text-[12px] py-[4px] px-2 rounded-md items-center gap-1"
                            onClick={downloadAllImages}
                          >
                            {" "}
                            <DownloadIcon className="h-4 w-4" /> Download All
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <TableCard2 className="!h-auto mt-[20px] !overflow-y-hidden">
                <ProjectTask projectKey={key} />
              </TableCard2>

              <div
                className="!h-[400px] mt-[20px] flex flex-col !py-[1px] relative overflow-hidden "
                // scrollClassName={"!overflow-hidden flex flex-col"}
              >
                <CommentsSection
                  type="project"
                  id={leadDetail?.projectid}
                  apiBaseUrl="project"
                  title="true"
                  // setAlertData={setAlertData}
                  projectOwner={leadDetail?.customer_details?.name}
                />
              </div>
            </TableCard>
          </div>
        </div>
      </div>

      {showBrief && (
        <ProjectBrief
          onClose={() => setShowBrief(false)}
          leadDetail={leadDetail}
        />
      )}
    </>
  );
}
